import { printPackingSlipInputSchema } from "@redotech/redo-model/packing-slips/print-input";
import * as z from "zod/v4";

export const printPackingSlip = {
  name: "printPackingSlip" as const,
  input: printPackingSlipInputSchema,
  output: z.object({ url: z.string(), batchFailed: z.boolean().nullish() }),
};
